import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BaseButton from './BaseButton';

// not needed in Enterprise website
const LinkButton = React.forwardRef(
  ({ href = '/', className, ...otherProps }, ref) => (
    <BaseButton
      ref={ref}
      tag="a"
      className={classNames('underline', className)}
      // anchor-specific prop
      href={href}
      // includes variant and appearance from Button
      {...otherProps}
    />
  ),
);

LinkButton.propTypes = {
  href: PropTypes.string,
};

export default LinkButton;
